import { DeliveryOption } from './../test/DeliveryOption';
import { async } from 'rxjs/internal/scheduler/async';
import { QuoteService } from './../test/quote.service';
import { ProductService } from './../test/product.service';
import { CustomerService } from './../test/customer.service';
import { PrintService } from './../print.service';
import { QuoteRepository as QuoteDao } from '../test/quote.dao';
import { TemplateRef, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TrTableComponent } from '../table/tr-table.component';
import { Component, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl, Form } from '@angular/forms';
import { Subscription, Observable, concat, defer, of, generate } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { MatRadioChange } from '@angular/material/radio';
import * as firebase from 'firebase';
import { DeliveryOptionService } from '../test/delivery-option.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { resolve } from 'url';
import { TrModalService } from '../modals/modal.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'lsu-quote',
  templateUrl: "quote.component.html",
  styleUrls: ["quote.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class QuoteComponent implements OnInit {
  @Output()
  change: EventEmitter<MatRadioChange>
  constructor(
    public ngfireStore: AngularFirestore,
    public modalService: TrModalService,
    public dialog: MatDialog,
    public router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public quoteService : QuoteService,
    public customerService: CustomerService,
    public productService: ProductService,
    public deliveryOptionService: DeliveryOptionService,
    private storage: AngularFireStorage,
    private printService: PrintService
  ) {
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 20, 0, 1);
    this.maxDate = new Date(currentYear + 1, 11, 31);
    this.router.routeReuseStrategy.shouldReuseRoute = () => false
  }
  availableProducts: Product[];
  deliveryOptions: DeliveryOption[];
  propertyTypes: any[];

  loading: boolean;

  isCommercial : boolean;
  total: number = 0;
  public netTotal: number = 0
  public productTotal: number = 0;
  public shippingTotal: number = 0;

  @ViewChild(TrTableComponent, { static: true })
  public table: TrTableComponent<any>

  public selectedProducts: Product[]
  public subscription: Subscription
  public dao: QuoteDao
  public columns: string[] = [
    "date",
    "productQuote",
    "freightQuote",
    "totalQuote",
    "action",
  ]

  orderForm: FormGroup;
  orderItems = [];
  productsMap: { [key: string]: Product } = {}
  filteredOrderItems: Observable<string[]>;
  itemNameOp = new FormControl('', Validators.required);
  propertyTypeSelected = ""
  customer: any;
  quoteId: any;
  edit: any = false;

  minDate: Date;
  maxDate: Date;

  public async ngOnInit(): Promise<void> {
    this.initForm();
    this.dao = new QuoteDao(this.customerService, this.productService, this.deliveryOptionService, this.ngfireStore, this.storage)
    this.dao.customerId = this.route.snapshot.paramMap.get("id")
    await this.modalService.showLoadingModal({
      title: "Loading Quote...",
      onOpen: async () => {
        await this.customerService.getCustomer(this.dao.customerId).then(doc =>{
          this.customer = { ...doc.data(), _id: doc.id }
        })
        await this.dao.initialize()
      }
    })
  }

  public async onAddQuote(edit: boolean, addQuoteDialog: TemplateRef<any>, event: MouseEvent, quote: any): Promise<void> {
    this.edit = edit;
    if (edit) {
      event.stopPropagation();
      this.quoteId = quote._id
    }
    this.dialog.open(addQuoteDialog, { width: "95vw" })
    await this.dao.initializeDetails()

    this.propertyTypes = this.dao.getPropertyTypes()
    this.propertyTypeSelected = this.customer.propertyType.id;

    if (!this.propertyTypeSelected) {
      const propertyTypeFound = this.propertyTypes.find(type => type.name === "Commercial")
      this.propertyTypeSelected = propertyTypeFound._id
    }

    this.isCommercial = this.checkPropertyType(this.propertyTypes, this.propertyTypeSelected)

    this.onPropertyTypeChange(this.propertyTypeSelected)
    this.deliveryOptions = this.dao.getDeliveryOptions()

    if (edit) {
     
      if(quote._id){
        this.orderForm.patchValue({_id: quote._id});
      }

      if(quote.deliveryAddress){
        this.orderForm.get('deliveryAddress').setValue(quote.deliveryAddress)
      }

      if(quote.notes){
        this.orderForm.get('notes').setValue(quote.notes)
      }

      if(quote.deliveryDate && quote.deliveryDate.toDate() > this.minDate){
        this.orderForm.get('deliveryDate').setValue(quote.deliveryDate.toDate())
      }

      let newSelectedProducts = [];
      quote.products.forEach(prod => {
        newSelectedProducts.push(this.availableProducts.find(product => product.name == prod.name))
      })

      this.selectedProducts = newSelectedProducts
      this.onProductChange()

      quote.products.forEach(quoteProduct => {
        if (quoteProduct.shipping) {
          this.productsMap[quoteProduct.name].shipping = parseFloat(quoteProduct.shipping) || 0
        }
        if (quoteProduct.total) {
          this.productsMap[quoteProduct.name].total = parseFloat(quoteProduct.total) || 0
        }
        if (quoteProduct.avgCostPerTon) {
          let totalCost = (parseFloat(quoteProduct.total) || 0 + parseFloat(quoteProduct.shipping) || 0)
          let qty = parseFloat(quoteProduct.qty) || 0;
          if (totalCost > 0 && qty > 0) {
            this.productsMap[quoteProduct.name].avgCostPerTon = totalCost / qty;
          }
        }
        if (quoteProduct.qty) {
          this.productsMap[quoteProduct.name].qty = parseFloat(quoteProduct.qty) || 0
        }

        if (quoteProduct.freightQuote) {
          this.productsMap[quoteProduct.name].freightQuote = parseFloat(quoteProduct.freightQuote) || 0
        }

        if (quoteProduct.deliveryOption) {
          const deliveryOption = this.deliveryOptions.find(o => o.name === quoteProduct.deliveryOption.name)
          if (deliveryOption) {
            this.productsMap[quoteProduct.name].deliveryOption = deliveryOption 
            this.productsMap[quoteProduct.name].deliveryOption.customPrice = false
          }
        }

        if (quoteProduct.shipping) {
          this.productsMap[quoteProduct.name].shipping = quoteProduct.shipping || 0
        }
      })
      this.netTotal = quote.totalQuote;
      this.productTotal = quote.productQuote;
      this.shippingTotal = parseFloat(quote.freightQuote)/60;
    }
  }
  productMapToProductArray(): Product[] {
    const productData = []
     Object.keys(this.productsMap).forEach(key => {
      productData.push(this.productsMap[key])
    });
    return productData
  }

  public async addQuote(): Promise<void> {
    this.onProductChange()
    this.dao.loading.next(true)
    const quote = {
      deliveryDate: firebase.firestore.Timestamp.fromDate(new Date(this.orderForm.get('deliveryDate').value)),
      products: this.productMapToProductArray(),
      date: firebase.firestore.Timestamp.fromDate(new Date()),
      deliveryAddress : this.orderForm.get('deliveryAddress').value,
      notes : this.orderForm.get('notes').value,
      totalQuote: this.netTotal,
      productQuote: this.productTotal,
      freightQuote: this.shippingTotal
    }

    if (this.dao.customerId && !this.edit) {
      this.table.addItem(quote, async c => {
        const ref = await this.quoteService.addQuote(this.dao.customerId, quote)
        return ref.id
      })
    }

    this.dao.loading.next(false)
    this.orderForm.value;
    this.clearNestedControls()
  }

  checkPropertyType(propertyTypes: any, propertyTypeSelected){
    let propertyType = propertyTypes.find(type => type._id === propertyTypeSelected)
    if(propertyType){
      return  propertyType.name === 'Commercial' ? true : false;
    }
  }

  clearNestedControls() {
    // this.orderItems = [] TODO: REMOVE ALL
    this.productsMap = {}
    this.selectedProducts = []
    this.orderForm.reset();
  }

  onCustomPriceChange(checked: boolean, product: Product): void {
    if (this.productsMap[product.name].deliveryOption) {
      this.productsMap[product.name].deliveryOption.customPrice = checked
      if (!checked) {
        const deliveryOption = this.deliveryOptions.find(option => option.name === this.productsMap[product.name].deliveryOption.name)
        if (deliveryOption) {
          this.productsMap[product.name].deliveryOption.price = deliveryOption.price
        }
      }
    }
  }

  onPropertyTypeChange(propertyId: any) {
    this.netTotal = 0;
    this.productTotal = 0;
    this.shippingTotal = 0;

    this.propertyTypeSelected = propertyId
    this.clearNestedControls()
    this.availableProducts = this.dao.getProducts()
  }

  get _id() {
    return this.orderForm.get('_id').value
  }

  onDeliveryOptionChange(deliveryOptionName: MatSelectChange, product: Product): void {
    const deliveryOption = this.deliveryOptions.find(option => option.name === deliveryOptionName.value)
    this.productsMap[product.name].deliveryOption = deliveryOption ? { ...deliveryOption } : {} as DeliveryOption
    this.onProductChange()
  }

  // onProductChange(selectedProducts: Product[]): void {
  onProductChange(): void {
    this.netTotal = 0;
    this.productTotal = 0;
    this.shippingTotal = 0;
   this.setProductMap() 
    
    // $20 truck *  (30 miles/ 25 + 0.5).
  }
setProductMap() {
  if (this.availableProducts) {
    this.availableProducts.forEach(product => {
      if (this.selectedProducts && this.selectedProducts.length) {
        if (this.selectedProducts.map(sp => sp.name).includes(product.name)) {
          // for newly added mat cell.
          if (!this.productsMap[product.name]) {
            this.productsMap[product.name] = { ...product }
            this.productsMap[product.name].qty = 1
            this.productsMap[product.name].price = this.getSelectedPrice(product);
            this.productsMap[product.name].total = this.productsMap[product.name].price * this.productsMap[product.name].qty
            this.productsMap[product.name].deliveryOption = this.productsMap[product.name].deliveryOption || {} as DeliveryOption
          }
          else {
            //Calculate item Price
            let currentProduct = this.productsMap[product.name];
            if (currentProduct && currentProduct.deliveryOption && currentProduct.freightQuote) {
              this.productsMap[product.name].shipping = currentProduct.deliveryOption.price * currentProduct.freightQuote // Shipping Price 
              this.productsMap[product.name].total = this.productsMap[product.name].price * this.productsMap[product.name].qty + this.productsMap[product.name].shipping;
              if (this.productsMap[product.name].shipping && this.productsMap[product.name].total && this.productsMap[product.name].qty) {
                this.productsMap[product.name].avgCostPerTon = this.productsMap[product.name].total / this.productsMap[product.name].qty
              }

              this.netTotal += this.productsMap[product.name].total
              this.productTotal += this.productsMap[product.name].price * this.productsMap[product.name].qty;
              this.shippingTotal += this.productsMap[product.name].shipping;

            }
          }
        } else {
          delete this.productsMap[product.name]
        }
      }
    })
  }
}
  getSelectedPrice(product: any) {
    let property = this.propertyTypes.find(x => x._id === this.propertyTypeSelected)
    if (property) {
      if (property.name === 'Commercial') {
        return product.commercialPrice;
      } else {
        return product.residentialPrice;
      }
    }
    return 0;
  }

  private initForm() {
    this.orderForm = this.fb.group({
      "_id" : this.fb.control(""),
      'deliveryDate': this.fb.control(''),
      'deliveryAddress' : this.fb.control(''),
      'notes' : this.fb.control('')
    });
  }

  onAddItem(productName: string) {
    this.orderItems.push(
      new FormGroup({
        'name': this.fb.control(productName, Validators.required),
        'qty': this.fb.control(0, [Validators.required, Validators.pattern(/^[0-9]+$/)]),
        'freightQuote': this.fb.control(0, [Validators.required, Validators.pattern(/^[0-9]+$/)]),
        'deliveryOption': this.fb.control(productName),
      })
    );
  }

  onDeleteItem(index: number) {
    this.orderItems.splice(index, 1);
  }

  getControls() {
    return this.orderItems
  }

  displayedColumns: string[] = [
    'name',
    'qty',
    'image',
    'price',
    'freightQuote',
    'deliveryOption',
    'shipping',
    'avgCostPerTon',
    'total',
  ];

  public async download(row: any) {
    await this.modalService.showLoadingModal({
      title: "Loading Quote...",
      onOpen: async () => {
        if (row._id) {
          await this.generateQuote(this.dao.customerId, row._id, false, false)
          const ref = this.storage.ref(`quoteDocuments/${row._id}.pdf`)
          const url = await ref.getDownloadURL().toPromise()
          window.open(url, "", "", true);
          return url
        }
        else {
          console.log('Failed  to download quote. Internal error.')
        }
      }
    })
  }

  public async viewQuote(event: any) {
   await this.modalService.showLoadingModal({
     title: "Loading Quote...",
     onOpen: async () => {
      try {
        await this.generateQuote(this.dao.customerId, event._id, false, false)
        await this.router.navigateByUrl(`invoice/downloadquote?customerId=${this.dao.customerId}&quoteId=${event._id}`)
      } catch (err) {
        console.error(err)
      }
     }
   })    
  }

  public async updateQuote() {
    this.onProductChange()
    //this.dao.loading.next(true)
    const quote = {
      _id : this.orderForm.get("_id").value,
      deliveryDate: firebase.firestore.Timestamp.fromDate(new Date(this.orderForm.get('deliveryDate').value)),
      products: this.productMapToProductArray(),
      deliveryAddress : this.orderForm.get('deliveryAddress').value,
      date: firebase.firestore.Timestamp.fromDate(new Date()),
      totalQuote: this.netTotal,
      productQuote: this.productTotal,
      freightQuote: this.shippingTotal,
      notes : this.orderForm.get('notes').value,
    }

   if (this.dao.customerId && this.edit) {
      this.table.updateItem(quote, async c => {
        const ref = await this.quoteService.updateQuote(this.dao.customerId,this.quoteId, quote)
      })
    }
    
   // this.dao.addItem(quote)
    //this.dao.loading.next(false)

    this.orderForm.value;
    this.clearNestedControls()

  }

  async onQuoteDelete(customerId : string, quoteId : string){
    this.modalService.showDeleteModal({
      title: "Delete Quote?",
      description: "Are you sure you want to delete this quote?",
      closeButtonText: "Close",
      deleteButtonText: "Delete",
      onDelete: async () => this.deleteQuote(customerId, quoteId)
    }, "Deleting Quote...")
    // const ref = this.dialog.open(ConfirmationDialogComponent, {
    //   data: { title: `Are you sure you want to delete quote ?`}
    // })

    //  const shouldAllow = await ref.afterClosed().toPromise()
    //  if (shouldAllow) {
    //    this.loading = true;
    //    await this.deleteQuote(customerId, quoteId)
    //    this.loading = false;
    // }
  }

  async deleteQuote(customerId: string, quoteId: string) {
    if (quoteId && customerId) {
      return this.table.deleteItem(quoteId, async () => {
        await this.quoteService.deleteQuote(customerId, quoteId)
      })
    }
  }

  public async onQuoteGenerate(customerId: string, quoteId: string, isEmail: boolean, isSMS: boolean){
      const ref = this.dialog.open(ConfirmationDialogComponent, {
        data: { title: `Are you sure you want to send ${isEmail ? 'Email' : 'SMS'} ?`}
      })

       const shouldAllow = await ref.afterClosed().toPromise()
       if (shouldAllow) {
         await this.modalService.showLoadingModal({
           title: "Generating Quote...",
           onOpen: async () => {
            await this.generateQuote(customerId, quoteId,isEmail, isSMS)
           }
         })
      }
  }

  async generateQuote(customerId: string, quoteId: string, isEmail: boolean, isSMS: boolean) {
    try {
      const quoteReport = firebase.functions().httpsCallable("sendQuote")
      const quoteRequest = {
        customerId: customerId,
        quoteId: quoteId,
        isEmail: isEmail,
        isSMS: isSMS
      }
      await quoteReport(quoteRequest)
    } catch (err) {
      const error = err as firebase.functions.HttpsError
      console.error(error)
    }
  }
}

export interface Product {
  name: string;
  propertyType: string;
  price: number;
  shipping?: number
  avgCostPerTon?: number
  total?: number
  qty?: number
  freightQuote?: number
  deliveryOption?: DeliveryOption
}